module.exports = __webpack_public_path__ + "static/media/17_3.1fcee247.png";